import { useState } from "react";
import Icons from "../myIcon/Icons";
import { Link } from "react-router-dom";

export default function Menu({ isOpen, setIsOpen }) {
    const handleLinkClick = () => { setIsOpen(false); };
    const [openInner, setOpenInner] = useState(null);

    return (
        <>
            <section className={isOpen ? "mobilemenu-area open-menu" : "mobilemenu-area close-menu"}>
                <div className="menu-leftside">
                    <button className="menu-close-btn mobile-mclose" onClick={() => { setIsOpen(false); }} aria-label="Close menu">Close</button>

                    <ul className="menu-mainlink">
                        <li>
                            <Link to={"/"} onClick={() => { setIsOpen(false); }}>
                                <span><small>(1)</small> Home</span> <p><Icons name="Longarrow_right" /></p>
                                <div></div>
                            </Link>
                        </li>
                        <li>
                            <Link to={"/about"} onClick={() => { setIsOpen(false); }}>
                                <span><small>(2)</small> About</span> <p><Icons name="Longarrow_right" /></p>
                                <div></div>
                            </Link>
                        </li>

                        <li>
                            <Link to={"/services"} onClick={() => { setIsOpen(false); }}>
                                <span><small>(3)</small> Services</span> <p><Icons name="Longarrow_right" /></p>
                                <div></div>
                            </Link>
                        </li>

                        <li>
                            <Link to={"/project"} onClick={() => { setIsOpen(false); }}>
                                <span><small>(4)</small> Projects</span> <p><Icons name="Longarrow_right" /></p>
                                <div></div>
                            </Link>
                        </li>

                        <li>
                            <Link to={"/production-unit"} onClick={() => { setIsOpen(false); }}>
                                <span><small>(5)</small> Production Unit</span> <p><Icons name="Longarrow_right" /></p>
                                <div></div>
                            </Link>
                        </li>

                        <li>
                            <Link to={"/blog"} onClick={() => { setIsOpen(false); }}>
                                <span><small>(6)</small> Blogs</span> <p><Icons name="Longarrow_right" /></p>
                                <div></div>
                            </Link>
                        </li>

                        <li>
                            <Link to={"/contact"} onClick={() => { setIsOpen(false); }}>
                                <span><small>(7)</small> Contact</span> <p><Icons name="Longarrow_right" /></p>
                                <div></div>
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="menu-rightside">
                    <button className="menu-close-btn" onClick={() => { setIsOpen(false); }} aria-label="Close menu">Close</button>

                    <h4 className="menu-heading">Saysha</h4>

                    <div className="menu-address">
                        <div>
                            <label><span>Know More</span></label>
                            <ul className="menulist-gap">
                                <li><Link to="mailto:info@saysha.in">info@saysha.in</Link></li>
                                <li><Link to="tel:+91-8397000603">+91-8397000603</Link></li>
                                <li><Link to="tel:+91-7770006015">+91-7770006015</Link></li>
                            </ul>

                            <label><span>Social</span></label>
                            <ul>
                                <li><Link to={"https://www.facebook.com/SayshaInterior"} target="_blank" aria-label="Facebook">Facebook</Link></li>

                                <li><Link to={"https://www.linkedin.com/company/saysha-interiors-pvt-ltd"} target="_blank" aria-label="linkedin">Linkedin</Link></li>

                                <li><Link to={"https://in.pinterest.com/sayshainterior"} target="_blank" aria-label="pinterest">Pinterest</Link></li>

                                <li><Link to={"https://twitter.com/sayshainteriors"} target="_blank" aria-label="twitter">Twitter</Link></li>

                                <li><Link to={"https://youtube.com/@sayshainteriors?si=IwVIclXE3UWuoXJj"} target="_blank" aria-label="youtube">Youtube</Link></li>

                                <li><Link to={"https://www.instagram.com/sayshainteriors?igsh=MXNqcXoxejJlaXF6Mg=="} target="_blank" aria-label="instagram">Instagram</Link></li>
                            </ul>
                        </div>

                        <div>
                            <label><span>Visit Us</span></label>
                            <ul className="menulist-gap break-address">
                                <li><span>D-43, 1st Floor, Sushant Lok </span></li>
                                <li><span>III Extension, Sector 57, </span></li>
                                <li><span>Gurugram, Haryana - 122011</span></li>
                            </ul>

                            <label><span>Opening Hours</span></label>
                            <ul>
                                <li><span>Monday to Saturday</span></li>
                                <li><span>10:00 AM - 07:00 PM</span></li>
                            </ul>
                        </div>
                    </div>

                    <p className="menu-copywrite"><span>© 2025 Saysha. All rights reserved.</span></p>
                </div>
            </section>
        </>
    )
}